import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[appInlineImageLimitWidth]' })
export class InlineImageLimitWidthDirective implements AfterViewInit {
    constructor(private elementRef: ElementRef) {}

    ngAfterViewInit(): void {
        this.limitImageWidth();
    }

    private limitImageWidth(): void {
        const images = this.elementRef.nativeElement.querySelectorAll('img');

        images.forEach((image) => {
            if (+image.getAttribute('width') > this.elementRef.nativeElement.offsetWidth) {
                const currentStyles = image.getAttribute('style');
                image.setAttribute('style', currentStyles + '; max-width: 100% !important; height: auto !important');
            }
        });
    }
}
